import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const UpdateWorkspaceMemberRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWorkspaceMemberRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWorkspaceMemberPermission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"workspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"UpdateWorkspaceMemberRole","document":UpdateWorkspaceMemberRoleDocument}} as const;
export type UpdateWorkspaceMemberRoleMutationVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
  traceId: Types.Scalars['String']['input'];
  type: Types.Scalars['String']['input'];
  workspaceId: Types.Scalars['ID']['input'];
}>;


export type UpdateWorkspaceMemberRoleMutation = (
  { __typename: 'Mutation' }
  & { updateWorkspaceMemberPermission?: Types.Maybe<(
    { __typename: 'UpdateWorkspaceMemberPermission_Response' }
    & Pick<Types.UpdateWorkspaceMemberPermission_Response, 'id'>
  )> }
);

export type UpdateWorkspaceMemberRoleMutationFn = Apollo.MutationFunction<
  UpdateWorkspaceMemberRoleMutation,
  UpdateWorkspaceMemberRoleMutationVariables
>;

/**
 * __useUpdateWorkspaceMemberRoleMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMemberRoleMutation, { data, loading, error }] = useUpdateWorkspaceMemberRoleMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      traceId: // value for 'traceId'
 *      type: // value for 'type'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpdateWorkspaceMemberRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkspaceMemberRoleMutation,
    UpdateWorkspaceMemberRoleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkspaceMemberRoleMutation,
    UpdateWorkspaceMemberRoleMutationVariables
  >(UpdateWorkspaceMemberRoleDocument, options);
}
export type UpdateWorkspaceMemberRoleMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceMemberRoleMutation
>;
export type UpdateWorkspaceMemberRoleMutationResult =
  Apollo.MutationResult<UpdateWorkspaceMemberRoleMutation>;
export type UpdateWorkspaceMemberRoleMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateWorkspaceMemberRoleMutation,
    UpdateWorkspaceMemberRoleMutationVariables
  >;
